<template>
	<div id="nav">
		<router-link to="/">
			<img
				alt="logo"
				src="../assets/logo-small.jpg"
			>
		</router-link>
		<router-link
			v-for="(item, i) in menuList"
			:key="i"
			:to="item.link"
			class="menu-item"
		>
			{{ currentMenuItem(item.name) }}
		</router-link>
		<div class="lang-container">
			<span
				v-if="false"
				class="lang-item"
				:class="{active: isLocale('ru')}"
				@click="setLocale('ru')"
			>Ру</span>
			<span
				v-if="false"
				class="lang-item"
				:class="{active: isLocale('ua')}"
				@click="setLocale('ua')"
			>Укр</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Menu',
		data () {
			return {
				menuList: [
					{
						link: '/',
						name: 'menu.main'
					},
					{
						link: '/about',
						name: 'menu.about'
					},
					{
						link: '/contacts',
						name: 'menu.contacts'
					}
				]
			};
		},
		computed: {
			isLocale () {
				return (locale) => {
					return this.$i18n.locale === locale;
				};
			},
			currentMenuItem () {
				return (str) => {
					return this.$t(str);
				};
			}
		},
		methods: {
			setLocale (locale) {
				//this.$i18n.locale = locale;
				import(`../langs/${locale}.json`).then(data => {
					this.$i18n.setLocaleMessage(locale, data);
					this.$i18n.locale = locale;
				});
			}
		}
	};
</script>

<style scoped lang="less">
	#nav {
		padding: 15px;
		/*min-height: 55px;*/
		height: 55px;
		border-bottom: 1px solid #cdcdcd;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		.menu-item {
			display: inline-block;
			padding: 5px 10px;
			margin: 0 10px;
			font-weight: bold;
			color: #fa5255;
			text-decoration: none;
			word-break: keep-all;
			white-space: nowrap;
			hyphens: none;
			&.router-link-exact-active {
				color: #2c3e50;
				&:hover{
					cursor: auto;
					opacity: 1;
				}
			}
			&:hover{
				opacity: 0.75;
			}
			@media (max-width: 453px) {
				margin: 0;
			}
			@media (max-width: 366px) {
				font-size: 0.85em;
			}
		}
		img{
			max-width: 60px;
			max-height: 40px;
			margin-right: 30px;
			margin-left: 20px;
			@media (max-width: 430px) {
				margin-right: 15px;
				margin-left: 5px;
			}
		}
		.lang-container{
			margin-left: auto;
			margin-right: 20px;
			.lang-item{
				display: inline-block;
				margin: 5px;
				padding: 5px;
				font-size: 0.8em;
				cursor: pointer;
				color: #fa5255;
				&.active{
					cursor: inherit;
					color: #2c3e50;
					&:hover{
						opacity: 1;
					}
				}
				&:hover{
					opacity: 0.8;
				}
			}
			@media (max-width: 580px) {
				margin: 0;
			}
			@media (max-width: 531px) {
				margin: auto;
			}

		}
		@media (max-width: 560px) {
			padding-right: 0;
			padding-left: 0;
		}
		@media (max-width: 531px) {
			flex-wrap: wrap;
			height: 100px;
		}
	}

</style>
